<template>
  <el-table
    :data="countTable"
    border
    style="width: 100%"
    :maxHeight="maxHeight"
    :span-method="arraySpanMethod"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      prop="channelTypeName"
      label="渠道分类"
      min-width="120"
      align="center" />
    <el-table-column
      prop="channelId"
      label="渠道ID"
      min-width="120"
      align="center"
    />
    <el-table-column
      prop="channelName"
      label="渠道名称"
      min-width="150"
      align="center"
    />
    <el-table-column
      prop="joinCount"
      label="入会人数"
      min-width="120"
      align="right"
      sortable
    />
    <el-table-column
      prop="recruitRatio"
      label="招募占比"
      min-width="120"
      align="right"
      sortable
    />
    <el-table-column
      prop="tradeCount"
      label="成交人数"
      min-width="120"
      align="right"
      sortable
    />
    <el-table-column
      prop="conversionRatio"
      label="转化率"
      min-width="120"
      align="right"
      sortable
    />
    <el-table-column
      prop="tradeAmount"
      label="成交金额"
      min-width="120"
      align="right"
      sortable
    />
    <el-table-column
      prop="tradeTimes"
      label="成交单量"
      min-width="120"
      align="right"
      sortable
    />
    <el-table-column
      prop="tradeNum"
      label="成交件数"
      min-width="120"
      align="right"
      sortable
    />
    <el-table-column
      prop="tradeAvgAmount"
      label="客单价"
      min-width="120"
      align="right"
      sortable
    />
  </el-table>
</template>

<script>
import mixins from "../../mixins/index.js";
import Empty from "../../components/empty.vue";
export default {
  name: "jdMembershipRecruitment",
  mixins: [mixins],
  components: {
    Empty,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
  },
  computed: {
    countTable() {
      return this.tableData.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          // 不需要处理得字段直接返回
          if (key === "channelId" || key === "channelName" || key === "channelTypeName") {
            newRow[key] = row[key];
            return;
          }
          // Ratio 字段 → 百分比
          if (key.includes("Ratio")) {
            newRow[key] = this.formatPercent(row[key]);
          } else {
            // 其他数值 → 普通数字
            newRow[key] = this.formatNumber(row[key]);
          }
        });
        if (newRow.channelName === "合计") {
          newRow.channelTypeName = "合计";
          newRow.channelId = "合计";
        }
        return newRow;
      });
    },
  },
  methods: {
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        if (columnIndex === 0) {
          return [1, 3];
        } else if (columnIndex === 1 || columnIndex === 2) {
          return [0, 0];
        }
      }
    },
  },
};
</script>
